angular.module("warsApp.filters").filter('substring', function () {
    return function (str, start, end) {
        if (str == undefined)
            return str;

        return str.substring(start, end);
    };
});